import React from "react";
import { Phone, MessageCircle, MapPin } from "lucide-react";
import LogoMark from "./Logo";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/8 bg-[#08090f] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <LogoMark size={44} />
              <div>
                <div className="font-display text-lg text-white">INELÉCTRICAS</div>
                <div className="font-mono text-[10px] text-white/40 tracking-[0.24em]">
                  ELECTRICIDAD · CANARIAS
                </div>
              </div>
            </div>
            <p className="mt-5 text-[14.5px] text-white/60 max-w-md leading-relaxed">
              Técnico electricista autónomo. Instalaciones, mantenimiento y
              averías con boletín eléctrico oficial y respuesta ágil en toda
              Canarias, con sede en Gran Canaria.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono text-[11px] text-white/40 tracking-widest mb-3">CONTACTO</div>
            <ul className="space-y-2 text-[14px] text-white/75">
              <li className="flex items-center gap-2">
                <Phone size={13} className="text-[#00E5FF]" />
                <a href="tel:+34617420491" className="hover:text-white">617 420 491</a>
              </li>
              <li className="flex items-center gap-2">
                <MessageCircle size={13} className="text-[#E57C23]" />
                <a href="https://wa.me/34617420491" target="_blank" rel="noreferrer" className="hover:text-white">
                  WhatsApp
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={13} className="text-white/50 mt-1" />
                <span>Calle Bilbao Nº53<br/>Telde · 35220</span>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="font-mono text-[11px] text-white/40 tracking-widest mb-3">ZONA DE SERVICIO</div>
            <div className="text-[14px] text-white/75 leading-relaxed">
              Telde · Las Palmas de Gran Canaria · Vecindario · Ingenio · Arinaga y alrededores.
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/8 flex flex-col sm:flex-row items-center justify-between gap-3 text-[12px] text-white/40">
          <div>© {new Date().getFullYear()} INELÉCTRICAS MOISÉS · Todos los derechos reservados.</div>
          <div className="font-mono">Francisco Moisés Castellano Monzón</div>
        </div>
      </div>
    </footer>
  );
}
